import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLayoutEdit } from '../context/LayoutEditContext';
import api from '../services/api';
import './Sidebar.css';
import { isFormsOnly } from '../utils/host';



// Alle versleepbare menu-items als data (Dashboard/Instellingen/Uitloggen zijn vast)
// De 'show' functie bepaalt op basis van de rol of het item überhaupt beschikbaar is
export const MENU_CONFIG = [
  { key: 'storingen',          icon: '🚨', label: 'Storingen',     path: '/storingen',            badgeKey: 'storingen',  show: (u, isW, hasPerm) => hasPerm('werkorders:storingen') },
  { key: 'meldingen', icon: '📣', label: 'Meldingen', path: '/meldingen', show: (u, isW, hasPerm) => hasPerm('meldingen:lezen') },
  { key: 'restwerk',           icon: '⚠️', label: 'Restwerk',      path: '/restwerk',             badgeKey: 'restwerk',   show: (u, isW, hasPerm) => hasPerm('werkorders:restwerk') },
  { key: 'ordernummers',       icon: '🔢', label: 'Ordernummers',  path: '/ordernummers',         show: (u, isW, hasPerm) => hasPerm('ordernummers:beheren') },
  { key: 'wagenpark',          icon: '🚐', label: 'Wagenpark',     path: '/wagenpark',            show: (u, isW, hasPerm) => hasPerm('wagenpark:beheren') },
  { key: 'toolboxen',          icon: '📚', label: 'Toolboxen',     path: '/toolboxen',            show: (u, isW, hasPerm) => hasPerm('toolboxen:lezen') },
  { key: 'uren-export',        icon: '📊', label: 'Uren Export',   path: '/uren-export',          show: (u, isW, hasPerm) => hasPerm('uren:export') },
  { key: 'facturen',           icon: '💰', label: 'Facturen',      path: '/facturen',             show: (u, isW, hasPerm) => hasPerm('facturatie:lezen') && u && u.facturatie_actief },
    { key: 'inzetmiddelen',       icon: '📦', label: 'Inzetmiddelen', path: '/inzetmiddelen',        show: (u, isW, hasPerm) => hasPerm('inzetmiddelen:lezen') },
  { key: 'onderaannemers', icon: '🏗️', label: 'Onderaannemers', path: '/onderaannemers', show: (u, isW, hasPerm) => hasPerm('onderaannemers:beheer') },
  { key: 'voorstellen', icon: '📥', label: 'Voorstellen', path: '/voorstellen', show: (u, isW, hasPerm) => hasPerm('werkorders:partijen') },
{ key: 'materialen',         icon: '🏭', label: 'Materialen',    path: '/materialen-beheer',    show: (u, isW, hasPerm) => hasPerm('materialen:lezen') },
  { key: 'projecten',          icon: '📁', label: 'Projecten',     path: '/projecten',            show: (u, isW, hasPerm) => hasPerm('projecten:lezen') },
  { key: 'bestellen',          icon: '📦', label: 'Bestellen',     path: '/bestellen',            badgeKey: 'materialen', show: (u, isW, hasPerm) => hasPerm('materialen:bestellen') },
  { key: 'voorraad',           icon: '🚐', label: 'Voorraad',      path: '/voorraad',             show: (u, isW, hasPerm) => hasPerm('materialen:bestellen') },
  { key: 'klanten',            icon: '📖', label: 'Klanten',       path: '/klanten',              show: (u, isW, hasPerm) => hasPerm('klanten:lezen'), dynamicLabel: 'klant_plural' },
  { key: 'opdrachtgevers', icon: '🏢', label: 'Opdrachtgevers', path: '/opdrachtgevers', show: (u, isW, hasPerm, modus) => hasPerm('opdrachtgevers:lezen') && modus === 'klant' },
  { key: 'brieven',            icon: '📝', label: 'Brieven',       path: '/brieven',              show: (u, isW, hasPerm) => !isFormsOnly() && (hasPerm('brieven:lezen_eigen') || hasPerm('brieven:lezen_alle')) }, // op forms-domein: tab onder Forms
  { key: 'forms-inbox',        icon: '📥', label: 'Inbox',         path: '/forms/inbox',          show: () => false }, // FORMS_TABS_SIDEBAR: tab onder Forms // alleen op forms-subdomein; verborgen op hoofddomein
  { key: 'quick-sign',         icon: '✍️',  label: 'Quick-Sign',    path: '/forms/quick-sign-multi', show: () => false }, // tab onder Forms // alleen op forms-subdomein
  { key: 'forms',              icon: '📝', label: 'Forms',         path: '/forms',                show: () => isFormsOnly() }, // alleen op forms-subdomein; op hoofddomein via URL /forms
  { key: 'metingen',           icon: '📐', label: 'Metingen',      path: '/metingen',             show: (u, isW, hasPerm) => hasPerm('metingen:beheer') },
  { key: 'formulieren',        icon: '📋', label: 'Formulieren',   path: '/formulieren',          show: (u, isW, hasPerm) => hasPerm('forms:inbox_lezen_eigen') || hasPerm('forms:inbox_lezen_alle') },
  { key: 'documenten',         icon: '📄', label: 'Documenten',    path: '/documenten',           show: (u, isW, hasPerm) => hasPerm('documenten:lezen') },
  { key: 'monteur-logs',       icon: '📝', label: 'Monteur Logs',  path: '/monteur-logs',         show: (u, isW, hasPerm) => hasPerm('monteur_logs:lezen') },
  { key: 'planning',           icon: '📅', label: 'Planning',      path: '/planning',             show: (u, isW, hasPerm) => hasPerm('planning:lezen') },
  { key: 'onderhoud',          icon: '🔧', label: 'Onderhoud',     path: '/onderhoud-overzicht',  show: (u, isW, hasPerm) => hasPerm('onderhoud:lezen') },
  { key: 'inhuur',            icon: '🤝', label: 'Inhuur',        path: '/inhuur',               show: (u, isW, hasPerm) => hasPerm('inhuur:lezen') },
  { key: 'onderhoud-forecast', icon: '📊', label: 'Forecast',      path: '/onderhoud-forecast',   show: (u, isW, hasPerm) => hasPerm('onderhoud:forecast') },
  { key: 'afgerond',           icon: '✅', label: 'Afgerond',      path: '/afgerond',             show: (u, isW, hasPerm) => hasPerm('werkorders:afgerond') },
  { key: 'doorgestuurd',       icon: '📤', label: 'Doorgestuurd',  path: '/doorgestuurd',         show: (u, isW, hasPerm) => hasPerm('werkorders:doorsturen') },
  { key: 'cursussen',          icon: '🎓', label: 'Cursussen',     path: '/cursus-planner',       show: (u, isW, hasPerm) => hasPerm('cursussen:lezen'), afterDivider: true },
  { key: 'afdelingen',         icon: '🏢', label: 'Afdelingen',    path: '/afdelingen',           show: (u, isW, hasPerm) => hasPerm('afdelingen:beheer') },
  { key: 'gebruikers',         icon: '👥', label: 'Gebruikers',    path: '/gebruikers',           show: (u, isW, hasPerm) => hasPerm('gebruikers:beheer') },
  { key: 'rollen-beheer',      icon: '🔐', label: 'Rollen',        path: '/rollen-beheer',        show: (u, isW, hasPerm) => hasPerm('gebruikers:rollen_beheer') },
  { key: 'portal-beheer', icon: '🌐', label: 'Klantportaal', path: '/portal-beheer', show: (u, isW, hasPerm) => hasPerm('portal:beheer') },
  { key: 'live-scherm', icon: '📺', label: 'Live scherm', path: '/live-scherm', show: (u, isW, hasPerm) => hasPerm('livescherm:beheer') },
  { key: 'templates',          icon: '📋', label: 'Templates',     path: '/templates',            show: (u, isW, hasPerm) => hasPerm('templates:beheer') },
  { key: 'import',             icon: '📥', label: 'Import',        path: '/import',               show: (u, isW, hasPerm) => hasPerm('import:gebruiken') },
  { key: 'kennisbank',         icon: '📚', label: 'Kennisbank',    path: '/kennisbank',           show: (u, isW, hasPerm) => hasPerm('kennisbank:lezen') },
  { key: 'weekrapport',        icon: '📊', label: 'Weekrapport',  path: '/weekrapport',          show: (u, isW, hasPerm) => hasPerm('rapportage:lezen') },
  { key: 'analyse',            icon: '📈', label: 'Analyse',       path: '/analyse',              show: (u, isW, hasPerm) => hasPerm('analyse:lezen') },
  { key: 'admin',              icon: '👑', label: 'Admin Panel',   path: '/admin',                show: (u) => u?.rol === 'super_admin' }
];

const Sidebar = () => {
  const { gebruiker, logout, terms, hasPermission, organisatieModus } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [storingenCount, setStoringenCount] = useState(0);
  const [restwerkCount, setRestwerkCount] = useState(0);
  const [materialenCount, setMaterialenCount] = useState(0);
  const [collapsed, setCollapsed] = useState(false);

  // Reorder state - editMode/saving komen uit globale context
  const { editMode, saving, startEdit, cancelEdit, saveAll, registerSaver } = useLayoutEdit();
  const [savedOrder, setSavedOrder] = useState(null);
  const [savedHidden, setSavedHidden] = useState([]);
  const [afdLabels, setAfdLabels] = useState({});

  useEffect(() => {
    if (!gebruiker?.id) return;
    api.get('/sidebar/labels')
      .then(res => setAfdLabels(res.data.labels || {}))
      .catch(() => setAfdLabels({}));
  }, [gebruiker?.id]);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [currentHidden, setCurrentHidden] = useState([]);
  const [dragKey, setDragKey] = useState(null);
  const [hoverKey, setHoverKey] = useState(null);

  // Permission-driven: counts laden zodra je er minstens een mag zien
  const canLoadCounts = hasPermission('werkorders:storingen') ||
                        hasPermission('werkorders:restwerk') ||
                        hasPermission('materialen:bestellen');

  // Counts laden — alleen op WOMsys-domain (niet op forms.womsys.nl)
  useEffect(() => {
    if (isFormsOnly()) return;
    if (canLoadCounts) {
      loadCounts();
      const interval = setInterval(loadCounts, 30000);
      return () => clearInterval(interval);
    }
  }, [canLoadCounts]);

  const loadCounts = async () => {
    try {
      const [storingenRes, restwerkRes, materialenRes] = await Promise.all([
        api.get('/storingen'),
        api.get('/klanten/restwerk/overzicht'),
        api.get('/materialen/bestellingen?status=te_bestellen')
      ]);
      setStoringenCount(storingenRes.data.storingen?.length || 0);
      setRestwerkCount(restwerkRes.data.restwerk?.length || 0);
      setMaterialenCount(materialenRes.data.bestellingen?.length || 0);
    } catch (error) {
      console.error('Error loading counts:', error);
    }
  };

  // Opgeslagen volgorde ophalen
  useEffect(() => {
    if (!gebruiker?.id) return;
    let alive = true;
    api.get('/sidebar/volgorde')
      .then(res => {
        if (!alive) return;
        setSavedOrder(res.data.volgorde);
        setSavedHidden(res.data.verborgen || []);
      })
      .catch(() => {
        if (alive) { setSavedOrder(null); setSavedHidden([]); }
      });
    return () => { alive = false; };
  }, [gebruiker?.id]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  const isActive = (path) => {
    if (path === '/dashboard' && location.pathname === '/') return true;
    // Exact match altijd actief
    if (location.pathname === path) return true;
    // Subpath: alleen actief als geen ANDER menu-item specifieker matcht
    if (location.pathname.startsWith(path + '/')) {
      const allPaths = MENU_CONFIG.map(i => i.path);
      const moreSpecific = allPaths.some(p =>
        p !== path &&
        p.startsWith(path + '/') &&
        (location.pathname === p || location.pathname.startsWith(p + '/'))
      );
      return !moreSpecific;
    }
    return false;
  };

  const badges = { storingen: storingenCount, restwerk: restwerkCount, materialen: materialenCount };

  // Bepaal welke items zichtbaar zijn voor deze user (permissies) en in welke volgorde
const formsOnly = isFormsOnly();
  const formsOnlyKeys = ['forms', 'forms-inbox', 'klanten', 'brieven', 'gebruikers', 'quick-sign'];
  const visibleItems = MENU_CONFIG.filter(item => {
    if (formsOnly && !formsOnlyKeys.includes(item.key)) return false;
    return item.show(gebruiker, canLoadCounts, hasPermission, organisatieModus);
  });

  const applyOrder = (items, order) => {
    if (!order) return items;
    const byKey = Object.fromEntries(items.map(i => [i.key, i]));
    const ordered = order.map(k => byKey[k]).filter(Boolean);
    const missing = items.filter(i => !order.includes(i.key));
    return [...ordered, ...missing];
  };

  const displayOrder = editMode ? currentOrder : applyOrder(visibleItems, savedOrder);
  const hiddenKeys = editMode ? currentHidden : savedHidden;

  // Wanneer edit start: kopieer opgeslagen state naar current
  useEffect(() => {
    if (editMode) {
      setCurrentOrder(applyOrder(visibleItems, savedOrder));
      setCurrentHidden([...savedHidden]);
    } else {
      setDragKey(null);
      setHoverKey(null);
    }
  }, [editMode]);

  // Registreer save/cancel handlers bij de context
  useEffect(() => {
    const unregister = registerSaver('sidebar', {
      onSave: async () => {
        const orderKeys = (currentOrder || []).map(i => i.key);
        const res = await api.put('/sidebar/volgorde', {
          volgorde: orderKeys,
          verborgen: currentHidden
        });
        setSavedOrder(res.data.volgorde);
        setSavedHidden(res.data.verborgen || []);
      },
      onCancel: () => {
        setDragKey(null);
        setHoverKey(null);
      }
    });
    return unregister;
  }, [currentOrder, currentHidden, registerSaver]);

  const resetSidebar = async () => {
    if (!window.confirm('Menu resetten naar standaard volgorde?')) return;
    try {
      await api.put('/sidebar/volgorde', { volgorde: null, verborgen: null });
      setSavedOrder(null);
      setSavedHidden([]);
      cancelEdit();
    } catch (e) {
      alert('Reset mislukt');
    }
  };

  // Drag handlers
  const handleDragStart = (key) => setDragKey(key);
  const handleDragOver = (e, key) => {
    e.preventDefault();
    if (dragKey && dragKey !== key) setHoverKey(key);
  };
  const handleDrop = (e, targetKey) => {
    e.preventDefault();
    if (!dragKey || dragKey === targetKey) return;
    const newOrder = [...currentOrder];
    const fromIdx = newOrder.findIndex(i => i.key === dragKey);
    const toIdx = newOrder.findIndex(i => i.key === targetKey);
    if (fromIdx < 0 || toIdx < 0) return;
    const [moved] = newOrder.splice(fromIdx, 1);
    newOrder.splice(toIdx, 0, moved);
    setCurrentOrder(newOrder);
    setDragKey(null);
    setHoverKey(null);
  };
  const handleDragEnd = () => { setDragKey(null); setHoverKey(null); };

  const toggleHidden = (key) => {
    setCurrentHidden(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  // Monteurs zien geen sidebar
  if (gebruiker?.rol === 'monteur') return null;

  // Render één menu-item
  const renderMenuItem = (item) => {
    const isHidden = hiddenKeys.includes(item.key);
    if (!editMode && isHidden) return null;

    const badge = item.badgeKey ? badges[item.badgeKey] : 0;
    const classes = [
      'menu-item',
      isActive(item.path) ? 'active' : '',
      editMode ? 'edit-mode' : '',
      dragKey === item.key ? 'dragging' : '',
      hoverKey === item.key ? 'hover-target' : '',
      isHidden && editMode ? 'hidden-in-edit' : ''
    ].filter(Boolean).join(' ');

    return (
      <div key={item.key} className="menu-item-wrapper">
        <div
          className={classes}
          onClick={() => !editMode && navigate(item.path)}
          draggable={editMode}
          onDragStart={() => handleDragStart(item.key)}
          onDragOver={(e) => handleDragOver(e, item.key)}
          onDrop={(e) => handleDrop(e, item.key)}
          onDragEnd={handleDragEnd}
        >
          {editMode && <span className="drag-handle">⋮⋮</span>}
          <span className="menu-icon">{afdLabels[item.key]?.icon || item.icon}</span>
          {!collapsed && <span className="menu-label">{afdLabels[item.key]?.label || (item.dynamicLabel && terms?.[item.dynamicLabel] ? terms[item.dynamicLabel] : item.label)}</span>}
          {!editMode && badge > 0 && <span className="menu-badge">{badge}</span>}
          {editMode && !collapsed && (
            <button
              className="hide-toggle"
              onClick={(e) => { e.stopPropagation(); toggleHidden(item.key); }}
              title={isHidden ? 'Tonen' : 'Verbergen'}
            >
              {isHidden ? '🙈' : '👁️'}
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${editMode ? 'edit-mode-active' : ''}`}>
      {/* Logo */}
      <div className="sidebar-header">
        <div className="logo" onClick={() => !editMode && navigate(formsOnly ? '/forms/inbox' : '/dashboard')}>
          {collapsed ? '📋' : <span>📋 WOM<span style={{color:'#00D4AA'}}>sys</span></span>}
        </div>
        <button className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? '→' : '←'}
        </button>
      </div>

      {/* Edit mode banner */}
      {editMode && !collapsed && (
        <div className="edit-banner">
          <strong>Menu bewerken</strong>
          <div style={{ fontSize: 11, marginTop: 2 }}>Sleep ⋮⋮ om te verplaatsen, 👁️ om te verbergen</div>
        </div>
      )}

      {/* Main Menu */}
      <div className="sidebar-menu">
        {/* Vast: Dashboard (verborgen voor forms-only) */}
        {!formsOnly && (
          <div
            className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`}
            onClick={() => !editMode && navigate('/dashboard')}
          >
            <span className="menu-icon">📊</span>
            {!collapsed && <span className="menu-label">Dashboard</span>}
          </div>
        )}

        {/* Versleepbaar gebied */}
        {(displayOrder || []).map((item, idx) => (
          <React.Fragment key={item.key}>
            {item.afterDivider && !editMode && <div className="menu-divider"></div>}
            {renderMenuItem(item)}
          </React.Fragment>
        ))}
      </div>

      {/* Footer */}
      <div className="sidebar-footer">
        {editMode ? (
          <div className="edit-actions">
            <button onClick={saveAll} disabled={saving} className="btn-save">
              {saving ? '…' : '✓ Opslaan'}
            </button>
            <button onClick={cancelEdit} disabled={saving} className="btn-cancel">
              ✗ Annuleren
            </button>
            <button onClick={resetSidebar} disabled={saving} className="btn-reset">
              ↺ Reset menu
            </button>
          </div>
        ) : (
          <>
            {!collapsed && !formsOnly && (
              <button className="edit-menu-btn" onClick={startEdit}>
                ✎ Layout bewerken
              </button>
            )}
            <div
              className={`menu-item ${isActive('/instellingen') ? 'active' : ''}`}
              onClick={() => navigate('/instellingen')}
            >
              <span className="menu-icon">⚙️</span>
              {!collapsed && <span className="menu-label">Instellingen</span>}
            </div>
            <div className="menu-item logout" onClick={handleLogout}>
              <span className="menu-icon">🚪</span>
              {!collapsed && <span className="menu-label">Uitloggen</span>}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
